import { makeStyles } from '@material-ui/core/styles';

const borderGray = 'rgba(213, 214, 221, 1)';
const textDark = 'rgba(69, 70, 83, 1)';
const textMid = 'rgba(120, 121, 142, 1)';
const brand = '#3F51B5';

const useStyles = makeStyles(() => ({
  /* Root */
  root: {
    padding: 24,
    boxSizing: 'border-box',
  },

  colWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    boxSizing: 'border-box',
  },

  /* Tabs */
  tabsBar: {
    height: 36,
    borderBottom: `1px solid rgba(233, 235, 245, 1)`,
    display: 'flex',
    boxSizing: 'border-box',
  },
  tab: {
    padding: '6px 8px',
    borderBottom: '1px solid transparent',
    marginBottom: 0,
    cursor: 'pointer',
  },
  tabActive: {
    borderBottom: `1px solid ${brand}`,
    marginBottom: -1,
  },
  tabLabel: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '24px',
    color: textMid,
  },
  tabLabelActive: {
    color: brand,
  },

  /* Grid */
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gap: 10,
    overflowY: 'auto',
    maxHeight: 570,
    boxSizing: 'border-box',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
  },

  /* Card */
  card: {
    minWidth: 350,
    height: 276,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    gap: 10,
    border: `1px dotted ${borderGray}`,
    borderRadius: 4,
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: '#fff',
  },
  cardSelected: {
    border: `1px solid ${brand}`,
  },

  /* Tick corner for selected card */
  cardTickCorner: {
    height: 32,
    width: 32,
    backgroundColor: brand,
    padding: 4,
    boxSizing: 'border-box',
    borderRadius: '0 0 0 4px',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  cardTickImg: { height: 24, width: 24 },

  /* Icon circle */
  iconCircle: {
    height: 92,
    width: 92,
    padding: 16,
    backgroundColor: 'rgba(245, 245, 245, 1)',
    borderRadius: 62,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  iconImg: { height: 60, width: 60 },

  /* Text block */
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    minWidth: 0,
  },
  cardTitle: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '21px',
    color: textDark,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  cardDesc: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: textDark,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },

  /* Highlights */
  highlightsWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  highlightRow: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
  },
  highlightIcon: { height: 18, width: 18 },
  highlightText: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: textMid,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  /* ===================== Responsiveness ===================== */

  /* ≤1440px */
  '@media (max-width:1440px)': {
    grid: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      maxHeight: 560,
    },
    card: { minWidth: 320, height: 270, padding: 22, gap: 10 },
    iconCircle: { height: 88, width: 88, padding: 14 },
    iconImg: { height: 56, width: 56 },
    cardTitle: { fontSize: 13, lineHeight: '20px' },
    cardDesc: { fontSize: 12, lineHeight: '16px' },
  },

  /* ≤1280px */
  '@media (max-width:1280px)': {
    grid: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      maxHeight: 540,
      gap: 10,
    },
    card: { minWidth: 300, height: 264, padding: 20 },
    iconCircle: { height: 84, width: 84, padding: 12 },
    iconImg: { height: 52, width: 52 },
    cardTitle: { fontSize: 13 },
    cardDesc: { fontSize: 12 },
  },

  /* ≤1024px */
  '@media (max-width:1024px)': {
    root: { padding: 16 },
    grid: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
      maxHeight: 'calc(100vh - 360px)',
      gap: 10,
    },
    card: { minWidth: 260, height: 'auto', padding: 16, gap: 8 },
    iconCircle: { height: 76, width: 76, padding: 10 },
    iconImg: { height: 48, width: 48 },
    cardTitle: { fontSize: 12, lineHeight: '18px' },
    cardDesc: { fontSize: 11, lineHeight: '16px' },

    tabsBar: { height: 'auto' },
    tab: { padding: '6px 8px' },
    tabLabel: { fontSize: 13, lineHeight: '20px' },
  },
}));

export default useStyles;
